import updateWCCart from "./updateWCCart";

export default (update = {}) => {
  let data = {
    ...update,
    // eslint-disable-next-line no-undef
    _wpnonce: palram.nonces.get_cart_nonce,
    update_cart: true,
  };

  const location = data.location || '';

  const setLoading = (location, load = 'add') => {
    if (!location) {
      return;
    }

    location = document.querySelector(`.${location}`);

    if (!location) {
      return;
    }

    location.classList[load]('element-blocked');
  }

  setLoading(location, 'add');

  let body = Object.entries(data).map(([key, val]) => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`).join('&');

  let xhr = new XMLHttpRequest();

  // eslint-disable-next-line no-undef
  xhr.open('post', palram.cartUrl);
  xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
  xhr.onload = () => {
    if (xhr.status === 200) {

      // Update mini cart in checkout page
      const cart = document.querySelector('.woocommerce-cart-form');

      if (cart) {
       updateWCCart(xhr.responseText);
      }

      // Refresh cart fragments
      document.body.dispatchEvent(new CustomEvent('wc_fragment_refresh'));

      // Update checkout if we are on checkout page
      // eslint-disable-next-line no-undef
      if ('1' === palram.isCheckout) {
        document.body.dispatchEvent(new CustomEvent('update_checkout'));
      }
    }
    setLoading(location, 'remove');
  }
  xhr.send(body);
}
